import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export type ShareholderEventsResponse = {
  events: string[];
};


export const getShareholdersEvents = (eventId: string): Promise<AxiosResponse<ShareholderEventsResponse>> => {
  return apiV1.get(`/v1/irm/event/${eventId}/shareholder`);
};

type QueryFnType = typeof getShareholdersEvents;

type UseShareholdersEventOptions = {
  companyId: string;
  eventId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useShareholdersEvents = ({ companyId, eventId, config }: UseShareholdersEventOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`shareholders-events`, companyId, eventId],
    queryFn: () => getShareholdersEvents(eventId),
    enabled: !!eventId, // 🔹 Evita chamadas desnecessárias
  });
};
